<template>
  <div :class="['o-feed-section-loading', $store.getters.getIsClientData === false
      ? 'o-feed-section-loading-upgrade' : '']">
    <MoleculeFeedSectionLoading/>
  </div>
</template>

<script>
export default {
  name: 'OrganismFeedSectionLoading',

  components: {
    MoleculeFeedSectionLoading: () => import('@/components/molecules/MoleculeFeedSectionLoading')
  }
}
</script>
